export const requestStatusOptions = [
  { label: "Canceled", value: "CANCELED" },
  { label: "Completed", value: "COMPLETED" },
  { label: "CTSU Testing", value: "CTSU_TESTING" },
  { label: "Draft", value: "DRAFT" },
  { label: "Group Testing", value: "GROUP_TESTING" },
  { label: "In Progress", value: "IN_PROGRESS" },
  { label: "New", value: "NEW" },
  { label: "Pending Signoff", value: "PENDING_SIGNOFF" },
  { label: "Retired", value: "RETIRED" },
  { label: "Submitted", value: "SUBMITTED" },
  { label: "UAT Setup", value: "UAT_SETUP" },
  { label: "Completed", value: "OPTIONAL_TRACKING" }
];

export const formTypeOptions = [
  { value: "OPEN/Rave", label: "OPEN/Rave" },
  { value: "Regulatory", label: "Regulatory" }
];

export const protocolTypeOptions = [
  { value: "CC", label: "Cancer Control/Prevention" },
  { value: "CCRD", label: "Cancer Care Delivery Research (CCDR)" },
  { value: "Treatment", label: "Treatment" }
];

export const requestTypeGroupOptions = [
  { value: "Amendment", label: "Amendment " },
  { value: "Revision", label: "Revision (Correction/Non-amendment revision)" },
  { value: "New", label: "New (New submission/New protocol)" }
];
export const all = { label: "All", value: "" };
